import type { ParagraphFeatures2Col as ParagraphFeatures2ColData } from "@/lib/api/cms-catalog";
import type { ParagraphTranslations } from "../Paragraph.i18n";
import styles from "./ParagraphFeatures2Col.module.css";

/**
 * Layout 40 - `PARAGRAPH_FEATURES_2COL_LAYOUT`: zaawansowane funkcje 2-col.
 *
 * Struktura:
 *   - Eyebrow (text_1) - uppercase accent label
 *   - H2 (name) - tytul sekcji
 *   - Lead (text) - paragraf pod tytulem (plain text z newlines)
 *   - Grid 2-kol z 6 slotow (kazda karta: ikona w boxie + nazwa + opis)
 *   - Puste sloty (bez name i desc) filtrowane po backendzie
 */
export function ParagraphFeatures2Col({
  paragraph,
}: {
  paragraph: ParagraphFeatures2ColData;
  t: ParagraphTranslations;
}) {
  const { text_1: eyebrow, name: title, text: lead, items } = paragraph;
  const hasEyebrow = eyebrow && eyebrow.trim() !== "";
  const hasLead = lead && lead.trim() !== "";
  const hasItems = Array.isArray(items) && items.length > 0;

  return (
    <section className={styles.section}>
      <div className={styles.header}>
        {hasEyebrow ? <p className={styles.eyebrow}>{eyebrow}</p> : null}
        {title ? <h2 className={styles.title}>{title}</h2> : null}
        {hasLead ? <p className={styles.lead}>{lead}</p> : null}
      </div>
      {hasItems ? (
        <div className={styles.grid}>
          {items.map((it, idx) => (
            <div key={idx} className={styles.card}>
              {it.icon ? (
                <div className={styles.iconBox} aria-hidden="true">
                  <i className={`nc-icon-outline ${it.icon}`} />
                </div>
              ) : null}
              <div className={styles.cardBody}>
                {it.name ? <h3 className={styles.name}>{it.name}</h3> : null}
                {it.desc ? <p className={styles.desc}>{it.desc}</p> : null}
              </div>
            </div>
          ))}
        </div>
      ) : null}
    </section>
  );
}
